import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { MdCall, MdEmail, MdListAlt, MdLocationPin, MdMail, MdPhone, MdWhatsapp } from "react-icons/md";

export default function ContactUsContent() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  const [formData, setFormData] = useState({
    fullName: "",
    company: "",
    emailOrPhone: "",
  });

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
		e.preventDefault();

		const subject = encodeURIComponent("Request Joining the TACHI team");
		const body = encodeURIComponent(
			`Full Name: ${formData.fullName}\n` +
			`Company / Project: ${formData.company}\n` +
			`Email / Phone: ${formData.emailOrPhone}\n`
		);

		const mailtoLink = `mailto:info@tachi.or.tz?subject=${subject}&body=${body}`;
		window.location.href = mailtoLink;
	};


  if (!ready)
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;

  return (
    <div
      className="MainBodySection bg-background"
      style={{ paddingTop: "50px", paddingBottom: "50px" }}
    >
      <div className="container">
        <div className="row">

          <div className="col-md-12 mb-4">
            <h6
              style={{ fontSize: "18px", lineHeight: "1.6" }}
              className="mb-3"
            >
              Fill the form below to Join Our Team
            </h6>
          </div>

          <div className="col-md-12 bg-surface p-5 mb-5">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label font-bold">Full Name</label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter your full name"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label font-bold">Company / Project Name</label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Company or Project Name"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label font-bold">Email / Phone</label>
                <input
                  type="text"
                  name="emailOrPhone"
                  value={formData.emailOrPhone}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Email or Phone"
                  required
                />
              </div>

              <div className="mt-3">
                <button
                  type="submit"
                  className="btn btn-padded btn-secondary mt-2"
                >
                  <MdListAlt size={24} /> Submit Request
                </button>
              </div>
            </form>
          </div>

          
        <div className="col-md-12 border rounded p-3">
          <h6
            style={{
              fontSize: "18px",
              padding: "10px",
              cursor: "pointer",
            }}
            onClick={() => {

              window.open('mailto:info@tachi.or.tz', '_blank')

            }}
            className="font-bold"
          >
            <MdEmail size={32}/> info@tachi.or.tz
          </h6>

          <h6
            style={{
              fontSize: "18px",
              padding: "10px",
              cursor: "pointer",
            }}
            onClick={() => {
              window.open('tel:+255 697 310 310', '_blank')
            }}
            className="font-bold"
          >
            <MdCall size={32}/> +255 697 310 310
          </h6>

          <h6
            style={{
              fontSize: "18px",
              padding: "10px",
              cursor: "pointer",
            }}
            onClick={() => {
              window.open("https://wa.me/+255749024050", "_blank");
          
            }}
            className="font-bold"
          >
            <MdWhatsapp size={32}/> chat with us on WhatsApp
          </h6>

          <h6
            style={{
              fontSize: "18px",
              padding: "10px",
              cursor: "pointer",
            }}
            onClick={() => {
              window.open("https://wa.me/+255749024050", "_blank");
          
            }}
            className="font-bold"
          >
            <MdLocationPin size={32}/> MBEYA, TANZANIA
          </h6>

        </div>

        </div>
      </div>
    </div>
  );
}
